<div class="patient-card" 
     *ngFor="let info of infos" 
     [class.alert-critical]="isAlertPatient(info.patientId)"
     (click)="onCardClick(info, $event)">
  <!-- 患者ヘッダー情報 -->
  <div class="patient-header">
    <div class="patient-header-top">
      <span class="patient-dept">{{ info.departmentName }}</span>
      <span class="patient-room">{{ info.room ? info.room + '号' : '' }}</span>
      <img src="assets/images/icon/timestudy.svg"
           alt="タイムスタディ"
           class="patient-timestudy-icon"
           (click)="onTimestudyClick(info, $event)">
    </div>
    <div class="patient-header-bottom">
      <span [ngClass]="getNameClass(info.patientName)" class="patient-name-clickable">{{ info.patientName }}{{ getGenderText(info.gender) }}</span>
    </div>
  </div>

  <!-- 四つの三角形容器 -->
  <div class="triangle-container">
    <!-- 上方三角形 - 注意事項（Assessment） -->
    <div class="tri-component tri-top">
      <div class="tri-bg" [ngClass]="getRiskColorClass(info.assessment?.score || 0)"></div>
      <div class="tri-icon" [ngClass]="triIconLayoutClass(getAssessmentIcons(info).length)">
        <ng-container *ngFor="let icon of getAssessmentIcons(info); let i = index">
          <div class="icon-circle">
            <img [src]="iconPath + icon" class="icon-svg" [alt]="icon">
          </div>
        </ng-container>
      </div>
    </div>

    <!-- 右側三角形 - 位置（Location） -->
    <div class="tri-component tri-right">
      <div class="tri-bg" 
           [ngClass]="getRiskColorClass(info.locationRisk?.score || 0)"
           (click)="onMovementHistoryClick(info, $event)"></div>
      <div class="tri-icon" [ngClass]="triIconLayoutClass(getLocationIcons(info).length)">
        <ng-container *ngFor="let icon of getLocationIcons(info); let i = index">
          <div class="icon-circle">
            <img [src]="iconPath + icon"
                 class="icon-svg"
                 [alt]="info.locationRisk?.zone || '自室'"
                 [attr.title]="i === 0 ? ('位置: ' + (info.locationRisk?.zone || '自室') + ' (アイコン: ' + icon + ')') : ''"
                 (error)="onImageError($event, info)">
          </div>
        </ng-container>
      </div>
    </div>

    <!-- 下方三角形 - 睡眠（Sleep） -->
    <div class="tri-component tri-bottom">
      <div class="tri-bg" [ngClass]="getRiskColorClass(info.sleepRisk?.score || 0)"></div>
      <div class="tri-icon" [ngClass]="triIconLayoutClass(getSleepIcons(info).length)">
        <ng-container *ngFor="let icon of getSleepIcons(info)">
          <div class="icon-circle">
            <img [src]="iconPath + icon" class="icon-svg" [attr.alt]="'睡眠' | hospLang">
          </div>
        </ng-container>
      </div>
    </div>

    <!-- 左側三角形 - 急変リスク（Acute Change） -->
    <div class="tri-component tri-left">
      <div class="tri-bg" [ngClass]="getRiskColorClass(info.acuteChangeRisk?.score || 0, true)"></div>
      <div class="tri-icon" [ngClass]="triIconLayoutClass(getAcuteChangeIcons(info).length)">
        <ng-container *ngFor="let icon of getAcuteChangeIcons(info)">
          <div class="icon-circle">
            <img [src]="iconPath + icon" class="icon-svg" alt="急変">
          </div>
        </ng-container>
      </div>
    </div>

    <!-- 対角線 -->
    <div class="diagonal-line diagonal-left"></div>
    <div class="diagonal-line diagonal-right"></div>
  </div>
</div>
